import React from 'react'

const WorkTickIcon = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
     
      <g mask="url(#mask0_16_26489)">
        <path
          d="M11.75 18C11.75 18.5167 11.8043 19.0293 11.913 19.538C12.021 20.046 12.1917 20.5333 12.425 21H4.75C4.2 21 3.72933 20.8043 3.338 20.413C2.946 20.021 2.75 19.55 2.75 19V8C2.75 7.45 2.946 6.97933 3.338 6.588C3.72933 6.196 4.2 6 4.75 6H8.75V4C8.75 3.45 8.946 2.979 9.338 2.587C9.72933 2.19567 10.2 2 10.75 2H14.75C15.3 2 15.771 2.19567 16.163 2.587C16.5543 2.979 16.75 3.45 16.75 4V6H20.75C21.3 6 21.771 6.196 22.163 6.588C22.5543 6.97933 22.75 7.45 22.75 8V12.275C22.1667 11.8583 21.5333 11.5417 20.85 11.325C20.1667 11.1083 19.4667 11 18.75 11C16.8167 11 15.1667 11.6833 13.8 13.05C12.4333 14.4167 11.75 16.0667 11.75 18ZM10.75 6H14.75V4H10.75V6Z"
          fill="#3249D7"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.75 23C17.3667 23 16.1877 22.5127 15.213 21.538C14.2377 20.5627 13.75 19.3833 13.75 18C13.75 16.6167 14.2377 15.4373 15.213 14.462C16.1877 13.4873 17.3667 13 18.75 13C20.1333 13 21.3127 13.4873 22.288 14.462C23.2627 15.4373 23.75 16.6167 23.75 18C23.75 19.3833 23.2627 20.5627 22.288 21.538C21.3127 22.5127 20.1333 23 18.75 23ZM21.1 19.65L20.4 20.35L18.25 18.2V15H19.25V17.8L21.1 19.65Z"
        fill="#3249D7"
      />
      <path
        d="M20.4 20.35L21.1 19.65L19.25 17.8V15H18.25V18.2L20.4 20.35Z"
        fill="#3249D7"
      />
      <path
        d="M18.0066 20.4867L21.75 16.7434L21.0066 16L18.0066 19L16.4934 17.4867L15.75 18.2301L18.0066 20.4867Z"
        fill="white"
      />
    </svg>
  )
}

export default WorkTickIcon
